import ApiSetting from './api'
import {postRequest} from './httpInterface.js'
const tool = {
  //调用微信的支付窗口
  gotoPay (appId, timeStamp, nonceStr, orderPackage, signType, paySign, orderNo) {
    function onBridgeReady () {
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          'appId': appId,          //公众号名称，由商户传入
          'timeStamp': timeStamp,  //时间戳，自1970年以来的秒数
          'nonceStr': nonceStr,    //随机串
          'package': orderPackage,
          'signType': signType,    //微信签名方式：
          'paySign': paySign       //微信签名
        },
        function (res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            // 调用后台走中
            var param = {
              'orderNo':orderNo
            }
            postRequest(ApiSetting.paying, param).then((res) => {
              if (res.data.responseCode == '200') {
                window.location.href = 'http://iehis.com/case-ui/myOrder';
              }
            })
          }
        })
    }

    if (typeof WeixinJSBridge == 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
      }
    } else {
      onBridgeReady()
    }
  },
  //base64转file
  dataURLtoFile (dataurl, filename) {
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, {type: mime})
  },
  // 压缩图片
  compress (img) {
    let originWidth = img.width, // 压缩后的宽
      originHeight = img.height,
      maxWidth = 600, maxHeight = 600,
      quality = 0.8, // 压缩质量
      canvas = document.createElement('canvas'),
      drawer = canvas.getContext('2d');
    // 目标尺寸
    let targetWidth = originWidth,
      targetHeight = originHeight
    // 图片尺寸超过300x300的限制
    if (originWidth > maxWidth || originHeight > maxHeight) {
      if (originWidth / originHeight > maxWidth / maxHeight) {
        // 更宽，按照宽度限定尺寸
        targetWidth = maxWidth
        targetHeight = Math.round(maxWidth * (originHeight / originWidth))
      } else {
        targetHeight = maxHeight
        targetWidth = Math.round(maxHeight * (originWidth / originHeight))
      }
    }
    canvas.width = targetWidth
    canvas.height = targetHeight
    drawer.clearRect(0, 0, canvas.width, canvas.height)
    drawer.drawImage(img, 0, 0, canvas.width, canvas.height)
    let base64 = canvas.toDataURL('image/jpeg', quality) // 压缩后的base64图片
    let file = this.dataURLtoFile(base64, Date.parse(Date()) + '.jpg')
    file = {content: base64, file: file}
    console.log(file)//压缩后的file
    return file
  }

}
export default tool
